;
(function ($) {
  var dataKey = 'app.autoFocus';
  var AutoFocus = function AutoFocus(element, options) {
    this.element = element;
    this.init(options);
  };
  AutoFocus.prototype = {
    attr: {
      groupItem: 'data-focus-item',
      length: 'data-focus-length'
    },
    /**
     * Initialise Auto Focus
     * Auto focus to next input within the focus group when max character limit is reached.
     * @public
     * @constructor
     * @param {string} options - Apply and extend options into init if needed.
     */

    init: function init(options) {
      $.extend(this.options, options);
      var _this = this;
      $(this.element).find('[' + this.attr.groupItem + ']').each(function () {
        var groupItem = $(this);
        var maxLength = _this._getMaximumCharacterLength(groupItem);
        var input = groupItem.find('input');
        input.on('click', function () {
          var originalValue = parseInt(input.val());
          input.keyup(function () {
            var nextGroupItem = groupItem.next('[' + _this.attr.groupItem + ']');
            if (input.val().length === maxLength) {
              var newValue = parseInt(input.val());
              if (newValue !== originalValue && nextGroupItem.length > 0) {
                $(nextGroupItem).find('input').focus();
              }
              originalValue = newValue;
            }
            _this._clipInputLength(input, maxLength);
          });
        });
      });
    },
    /**
     * Get Input Max Character Length
     * Returns the input max character length.
     * @private
     * @param {element} elm - The input group item element.
     */

    _getMaximumCharacterLength: function _getMaximumCharacterLength(elm) {
      return parseInt(elm.attr(this.attr.length));
    },
    /**
     * Clip Character Length
     * Clips the input value after the provided character limit.
     * @private
     * @param {element} elm - The input group item element.
     * @param {length} elm - The input character length.
     */

    _clipInputLength: function _clipInputLength(elm, length) {
      var subString = elm.val().substring(0, length);
      elm.val(subString);
    }
  };

  /**
   * Global callback function which by default all [data-focus-group] triggers this plugin.
   * @method $.fn.app_autoFocus()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_autoFocus();
   */

  $.fn.app_autoFocus = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof AutoFocus) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new AutoFocus(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);